import styled from 'styled-components';

export const Content = styled.div`
  .view-toggle .btn {
    background: #fff;
    border-color: ${(props) => props.theme.$gray400};
    color: ${(props) => props.theme.$gray700};

    .material-icons {
      font-size: 20px;
    }

    &.active {
      background: ${(props) => props.theme.$blue800};
      border-color: ${(props) => props.theme.$blue800};
      color: #fff;
    }
  }

  .bidding-orgao {
    max-width: 320px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  tr.is-selected td {
    border-top: 1px solid ${(props) => props.theme.$success};
    border-bottom: 1px solid ${(props) => props.theme.$success};

    &:first-child {
      border-left: 1px solid ${(props) => props.theme.$success};
    }

    &:last-child {
      border-right: 1px solid ${(props) => props.theme.$success};
    }
  }
`;
